import { useState } from "react";
import { usePoll } from "@/hooks/usePoll";
import { useAdmin, RoleChip } from "@/admin/AdminContext";
import { PageHeader } from "@/components/Badges";
import { actionLabel } from "@/admin/pages/Overview";

const ACTIONS = [["", "All actions"], ["admin.login", "Logins"], ["user.status", "Status changes"], ["user.role", "Role changes"], ["user.plan", "Plan assignments"],
  ["user.assign_manager", "Manager assignments"], ["user.delete", "Deletions"], ["plan", "Plans"], ["system", "System settings"]];

const fmtDetails = (d) => Object.entries(d || {}).map(([k, v]) => (v && typeof v === "object" && "to" in v ? `${k}: ${v.from ?? "—"} → ${v.to ?? "—"}` : `${k}: ${v ?? "—"}`)).join(" · ");

export default function Logs() {
  const { can } = useAdmin();
  const [action, setAction] = useState("");
  const [actor, setActor] = useState("");
  const params = new URLSearchParams({ ...(action && { action }), ...(actor && { actor }) });
  const { data } = usePoll(`/admin/logs?${params}`, 30000, [action, actor]);
  return (
    <div data-testid="admin-logs-page">
      <PageHeader title="Activity Logs" sub={can("view_all_logs") ? "Every action taken by staff in the admin portal" : "Your own admin actions"} />
      <div className="flex flex-wrap gap-2 mb-3">
        <select value={action} onChange={(e) => setAction(e.target.value)} data-testid="logs-action-filter"
          className="bg-white border border-zinc-200 rounded-sm text-xs px-2 py-1.5 focus:outline-none focus:border-[#7C3AED]">
          {ACTIONS.map(([k, l]) => <option key={l} value={k}>{l}</option>)}
        </select>
        {can("view_all_logs") && <input value={actor} onChange={(e) => setActor(e.target.value)} placeholder="Filter by staff email" data-testid="logs-actor-filter"
          className="px-3 py-1.5 text-xs border border-zinc-200 rounded-sm w-56 focus:outline-none focus:border-[#7C3AED]" />}
      </div>
      <div className="panel overflow-x-auto scrollbar-thin">
        <table className="w-full text-sm" data-testid="logs-table">
          <thead className="bg-zinc-50 border-b border-zinc-200"><tr>{["Time (UTC)", "Staff", "Role", "Action", "Target", "Details"].map((h) => <th key={h} className="px-3 py-2 text-left label-xs">{h}</th>)}</tr></thead>
          <tbody>
            {(data || []).map((l, i) => (
              <tr key={i} className="border-b border-zinc-100" data-testid={`log-row-${i}`}>
                <td className="px-3 py-2 num text-[11px] text-zinc-500 whitespace-nowrap">{new Date(l.created_at).toUTCString().slice(5, 25)}</td>
                <td className="px-3 py-2 text-xs text-zinc-900">{l.actor_email}</td>
                <td className="px-3 py-2"><RoleChip role={l.actor_role} /></td>
                <td className="px-3 py-2 text-xs capitalize font-medium">{actionLabel(l.action)}</td>
                <td className="px-3 py-2 text-xs text-zinc-700">{l.target_label || "—"}</td>
                <td className="px-3 py-2 text-[11px] text-zinc-500 max-w-[380px]">{fmtDetails(l.details) || "—"}</td>
              </tr>
            ))}
            {data && !data.length && <tr><td colSpan={6} className="p-8 text-center text-sm text-zinc-500" data-testid="logs-empty">No matching activity.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
